module.exports = {
      id: "padlock-usage",
      viewBox: "0 0 30 30",
      url: "img/" + "sprite.svg#padlock-usage",
      toString: function () {
        return this.url;
      }
    }